import React, { useEffect, useImperativeHandle, useState } from "react";
import { DatePicker } from "antd";
import { CONSTANT } from "../../config/Constant";
import dayjs from "dayjs";

interface AntdDateFloatingFilterProps {
  parentFilterInstance: (cb: (instance: any) => void) => void;
}

const DISPLAY_FORMAT = CONSTANT.DATE_FORMAT;


function isValidDate(dateString:any) {
   // Try to parse the string as a Date
 const date = new Date(dateString);
  return !isNaN(date.getTime());
}

const AntdDateFloatingFilter = React.forwardRef<any, AntdDateFloatingFilterProps>(
  (props, ref) => {
    const [value, setValue] = useState<any>(null);

    useImperativeHandle(ref, () => ({
      onParentModelChanged(model: any) {
        if (!model || !model.filter) {
          setValue(null);
        } else {
          console.log('model', model);
          setValue(model.filter);
          // if(isValidDate())
          // {
          //   setValue(dayjs(model.filter));
          // }
        }
      },
    }));

    useEffect(() => {
      // communicate to parent filter using the expected hook
      props.parentFilterInstance((instance: any) => {
        console.log('value',value, value && isValidDate(value) ? dayjs(value).format(CONSTANT.DATE_FORMAT) : value)
        if (!value) {
          instance.onFloatingFilterChanged("equals", null);
        } else {
          instance.onFloatingFilterChanged("equals",value && isValidDate(value) ? dayjs(value).format(CONSTANT.DATE_FORMAT) : value);
        }
      });
    }, [value]);

    return (
      <DatePicker
        value={value && isValidDate(value) ? dayjs(value) : null}
        onChange={(d) => setValue(d)}
        format={DISPLAY_FORMAT}
        placeholder={DISPLAY_FORMAT}
        allowClear
        size="small"
        style={{ width: "100%" }}
      />
    );
  }
);

export default AntdDateFloatingFilter;


